<template>
    <div  class="col-lg-12 empty-list_image reportAreaContentPart2"
          :class="divEditListRedBorder ? 'redborder' : ''" id="divEditList">
        <strong v-if="ddlClass === ''">{{lang("Select Class")}}</strong>
        <strong v-else-if="ddlStudent === ''">{{lang("Select Student")}}</strong>
        <strong v-else>{{lang("Select Action")}}</strong>
        <img src="../../../assets/notfound.png"/>
    </div>
</template>

<script>
    import {lang} from "../../../locale";
    import K2Row from "../../../uiComponents/k2Row/k2Row";
    import K2Text from "../../../uiComponents/k2Text/k2Text";

    export default {
        name: "TermlyModeNo",
        props: ["divEditListRedBorder", "ddlClass", "ddlStudent"],
        data() {
            return {
            };
        },
        methods: {
            lang,
        }
    };

</script>
<style lang="scss" scoped>
    @import "../termly";
</style>